function getTimeRemaining(endtime) {
  let t = Date.parse(endtime) - Date.parse(new Date());
  let seconds = Math.floor((t / 1000) % 60);
  let minutes = Math.floor((t / 1000 / 60) % 60);
  let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  let days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(id, endtime) {
  let clock = document.getElementById(id);
  let daysSpan = clock.querySelector('.days');
  let hoursSpan = clock.querySelector('.hours');
  let minutesSpan = clock.querySelector('.minutes');
  let secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    let t = getTimeRemaining(endtime);

    function displayDigits(zero = false) {
      daysSpan.innerHTML = (zero ? '0' : ('0' + t.days)).slice(-2);
      hoursSpan.innerHTML = (zero ? '0' : ('0' + t.hours)).slice(-2);
      minutesSpan.innerHTML = (zero ? '0' : ('0' + t.minutes)).slice(-2);
      secondsSpan.innerHTML = (zero ? '0' : ('0' + t.seconds)).slice(-2);
    }

    if (t.total <= 0) {
      displayDigits(true);
      return;
    }

    displayDigits();
  }

  updateClock();
  let timeinterval = setInterval(updateClock, 1000);
}

let deadline="July 10 2025 23:59:59 GMT+0300"; //for Ukraine
initializeClock('clockdiv', deadline);
